export default {
  hotpads: 'hotpads',
  trulia: 'trulia',
  zillow: 'zillow',
} as const;